const descriptorItem = {
  bindings: {
    data: '<',
    type: '<',
    sanctionedExists: '<',
    validExists: '<',
    engineeringExists: '<',
    onDelete: '&',
    onUpdate: '&',
  },
  templateUrl:
    '/modules/packageManagement/descriptor-management/descriptors-list/descriptor-item/descriptor-item.html',
  controller: 'descriptorItemController',
};

angular
  .module('package-management.module')
  .component('descriptorItem', descriptorItem);
